import { Injectable } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Subject } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ControlVelocidadService {

  private filtroForm = new Subject<any>(); //Valor modificado para cargar el componente
  public firstFiltroForm; //Valor Inicial al cargar el componente
  qs = require('qs');

  constructor(
    private gtp: Gtp,
    private http: HttpClient
  ) { }

  getFiltroForm(){
    return this.filtroForm.asObservable();
    //return this.filtroForm;
  }

  setFiltroForm(filtro){
    this.filtroForm.next(filtro);
  }

  getControlVelocidadMoviles(filtro){
    let orden = (filtro.sortby == "asc") ? filtro.orderby : "-" +filtro.orderby;
    var filter = {
        limit: filtro.pageSize,
        offset: filtro.pageIndex,
        order: orden,
        controlvelocidades: {
          fecha_hora: {
            between: [filtro.desde,filtro.hasta]
          },
          //velocidad: [filtro.velocidad, filtro.limite_velocidad],
          velocidad:filtro.velocidad,
          order: "fecha_hora"
        },
    };

    var qs = require('qs');
    //let urlFilter = qs.stringify(filter);
    //urlFilter = qs.parse(urlFilter); // Volver a parsear como object
    return this.http.post(`${environment.baseUrl}clientes/control-flota/control-velocidades/`,filter)
      .pipe(
        timeout(60000), // 60 segundos de timeout
        catchError(error => {
          console.warn('Timeout en petición de control de velocidades:', error);
          return throwError(error);
        })
      );
  }

  async getControlVelocidadMovilesOptimized(filtro, total: any = false) {
    let orden = (filtro.sortby == "asc") ? filtro.orderby : "-" + filtro.orderby;
    var limit = 20;
    var offset = 0;
    var filter = {
      limit: limit,
      offset: offset,
      order: orden,
      controlvelocidades: {
        fecha_hora: {
          between: [filtro.desde, filtro.hasta]
        },
        velocidad: filtro.velocidad,
        order: "fecha_hora"
      },
    };

    try {
      let info = await this.bigApiCallWithTimeout(filter, total, `${environment.baseUrl}clientes/control-flota/control-velocidades/`, 'rows');
      return info;
    } catch (error) {
      console.error('Error en getControlVelocidadMovilesOptimized:', error);
      throw error;
    }
  }

  async bigApiCallWithTimeout(filter, total, endpoint, rows) {
    var cantCalls = (total) ? total : 1; // total de registros
    var limit = (filter.limit) ? filter.limit : 20; // cantidad a llamar por lote
    var cant = (filter.limit) ? filter.limit : 20; // cantidad máx de registros, en caso de ser menor retorna lo que cuente
    var results = []; // almacena los resultados del api
    var offset = 0;

    for (let i = 0; i < cantCalls; i++) {
      offset = i * cant;
      filter.limit = limit;
      filter.offset = offset;
      try {
        // Agregar timeout de 60 segundos específicamente para control de velocidades
        const res = await this.http.post(endpoint, filter)
          .pipe(
            timeout(60000), // 60 segundos de timeout
            catchError(error => {
              if (error.name === 'TimeoutError') {
                console.warn('Timeout en consulta de control de velocidades:', error);
                return throwError('La consulta está tardando más de lo esperado. Por favor, intente con un rango de fechas más pequeño.');
              } else {
                console.error('Error en consulta de control de velocidades:', error);
                return throwError('Error al cargar los datos. Por favor, intente nuevamente.');
              }
            })
          ).toPromise();

        if (rows){
          results = results.concat(res[rows]);
          if (res[rows].length < cant) { break; }
        } else {
          results = results.concat(res);
          if (Object.values(res).length < cant) { break; }
        }

      } catch (error) {
        console.log('Ha ocurrido un error en bigApiCallWithTimeout');
        // Si hay timeout o error, retornar los resultados parciales obtenidos hasta ahora
        if (results.length > 0) {
          console.log(`Retornando ${results.length} resultados parciales debido a error/timeout`);
          break;
        } else {
          throw error; // Si no hay resultados parciales, propagar el error
        }
      }
    }
    return results;
  }

  getControlVelocidadMovilesExport(filtro, tableCount) {
    var filter = {
      equipoRastreo: {
        des_equipo_ratreo: {
          "iLike": '%'+filtro.buscar+'%'
        },
      },
      limit: tableCount,
      offset: 0,
      mensajes: {
        fecha_hora: {
            between:  [filtro.desde,filtro.hasta]
        },
        velocidad: {
            gte: filtro.velocidad
        },
        limit: filtro.pageSize,
        offset: filtro.pageIndex
      }
    };
    let urlFilter = this.qs.stringify(filter);
    return this.http.get(`${environment.baseUrl}clientes/control-flota/ver-flota/?`+urlFilter)
      .pipe(
        timeout(90000), // 90 segundos para exports (pueden ser más pesados)
        catchError(error => {
          console.warn('Timeout en exportación de control de velocidades:', error);
          return throwError(error);
        })
      );
  }

  getControlVelocidadMovilExport(filtro, tableCount){
    let orden = (filtro.sortby=="asc") ? "-"+filtro.orderby : filtro.orderby;
    var filter = {
      order: orden,
      fecha_hora: {
        between: [filtro.desde,filtro.hasta]
      },
      velocidad: [filtro.velocidad],
    };
    let urlFilter = this.qs.stringify(filter);
    return this.http.post(`${environment.baseUrl}clientes/control-flota/control-velocidades/${filtro.codequipo}/mensajes`,filter)
      .pipe(
        timeout(90000), // 90 segundos para exports
        catchError(error => {
          console.warn('Timeout en exportación de móvil específico:', error);
          return throwError(error);
        })
      );
    //return this.http.get(`${environment.baseUrl}clientes/vehiculos/${filtro.codequipo}/mensajes?`+urlFilter);
  }

  getControlVelocidadMovil(codvehiculo, filtro){
    let orden = (filtro.sortby=="asc") ? filtro.orderby : "-"+filtro.orderby;
    var filter = {
      order: orden,
      fecha_hora: {
        between: [filtro.desde,filtro.hasta]
      },
      velocidad: filtro.velocidad,
      // fecha_hora: {
      //   between: [filtro.desde,filtro.hasta]
      // },
      // velocidad: filtro.velocidad,
      // order: "fecha_hora"
    };
    let urlFilter = this.qs.stringify(filter);
    return this.http.post(`${environment.baseUrl}clientes/control-flota/control-velocidades/${codvehiculo}`,filter)
      .pipe(
        timeout(45000), // 45 segundos para móvil individual
        catchError(error => {
          console.warn('Timeout en petición de móvil específico:', error);
          return throwError(error);
        })
      );
    //return this.http.get(`${environment.baseUrl}clientes/vehiculos/`+codvehiculo+`/mensajes?`+urlFilter);
  }

  getVelocidadConstanteMoviles(filtro) {
    var filter = {
      limit: 1000, // Aumentar el límite para obtener todos los excesos
      offset: 0,
      vel_max: filtro.limite_velocidad || filtro.velocidad,
      fecha_hora: {
        between: [filtro.desde, filtro.hasta]
      },
    };

    // console.log('Enviando al backend:', filter);
    //let urlFilter = this.qs.stringify(filter);
    return this.http.post(`${environment.baseUrlV2}clientes/control-flota/control-velocidad-constante/${filtro.cod_equipo_rastreo}?`, filter)
      .pipe(
        timeout(60000), // 60 segundos para velocidad constante
        catchError(error => {
          console.warn('Timeout en petición de velocidad constante:', error);
          return throwError(error);
        })
      );
  }

  async getVelocidadConstanteMovilesOptimized(filtro, total: any = false) {
    // Por ahora, vamos a usar el método original pero optimizado
    // El endpoint de velocidad constante parece requerir un vehículo específico
    console.log('getVelocidadConstanteMovilesOptimized llamado con:', filtro, total);

    // Retornar un array vacío por ahora para debuggear
    return [];
  }

  async bigApiCallWithTimeoutVelocidadConstante(filter, total, endpoint, rows) {
    var cantCalls = (total) ? total : 1; // total de registros
    var limit = (filter.limit) ? filter.limit : 20; // cantidad a llamar por lote
    var cant = (filter.limit) ? filter.limit : 20; // cantidad máx de registros, en caso de ser menor retorna lo que cuente
    var results = []; // almacena los resultados del api
    var offset = 0;

    for (let i = 0; i < cantCalls; i++) {
      offset = i * cant;
      filter.limit = limit;
      filter.offset = offset;
      try {
        // Agregar timeout de 60 segundos específicamente para control de velocidad constante
        const res = await this.http.post(endpoint, filter)
          .pipe(
            timeout(60000), // 60 segundos de timeout
            catchError(error => {
              if (error.name === 'TimeoutError') {
                console.warn('Timeout en consulta de velocidad constante:', error);
                return throwError('La consulta está tardando más de lo esperado. Por favor, intente con un rango de fechas más pequeño.');
              } else {
                console.error('Error en consulta de velocidad constante:', error);
                return throwError('Error al cargar los datos. Por favor, intente nuevamente.');
              }
            })
          ).toPromise();

        if (rows){
          results = results.concat(res[rows]);
          if (res[rows].length < cant) { break; }
        } else {
          results = results.concat(res);
          if (Object.values(res).length < cant) { break; }
        }

      } catch (error) {
        console.log('Ha ocurrido un error en bigApiCallWithTimeoutVelocidadConstante');
        // Si hay timeout o error, retornar los resultados parciales obtenidos hasta ahora
        if (results.length > 0) {
          console.log(`Retornando ${results.length} resultados parciales debido a error/timeout`);
          break;
        } else {
          throw error; // Si no hay resultados parciales, propagar el error
        }
      }
    }
    return results;
  }

}
